






























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { List, Checkbox, CheckboxGroup, Button, Loading } from 'vant';
import SearchInput from './SearchInput.vue';
import VoteButton from '@/components/VoteButton.vue';
import { getVoteList } from '../api';
Vue.use(List).use(Checkbox).use(CheckboxGroup).use(Button).use(Loading);
@Component({
  components: {
    SearchInput,
    VoteButton,
  },
})
export default class VoteList extends Vue {
  @Prop() options!: any;
  @Prop({ default: 1 }) type!: any;
  @Prop({ default: 1 }) workType!: any;
  @Prop({ default: 0 }) county!: any;
  loading = false;
  finished = false;
  loadingStatus = false;
  page = 1;
  getListData: any[] = [];
  result = [];
  SearchData = '';
  showLoading = false;
  @Watch('type')
  public onTypeChange() {
    this.reset();
    setTimeout(() => {
      this.onLoad();
    }, 100);
  }
  @Watch('workType')
  public onWorkTypeChange() {
    this.reset();
    setTimeout(() => {
      this.onLoad();
    }, 100);
  }
  @Watch('county')
  public onCountyChange() {
    this.reset();
    setTimeout(() => {
      this.onLoad();
    }, 100);
  }
  get source() {
    return this.$route.params.source;
  }
  public reset() {
    this.page = 1;
    this.loading = false;
    this.finished = false;
    this.loadingStatus = false;
    this.getListData = [];
    this.showLoading = false;
  }
  // 初使加载
  onLoad() {
    console.log('onLoad加载开始了。搜索内容为：', this.SearchData);
    this.showLoading = true;
    if (this.loadingStatus === false) {
      this.loadingStatus = true;
      if (this.SearchData) {
        this.startSearch(2);
      } else {
        setTimeout(() => {
          getVoteList({
            page: this.page,
            workType: this.workType,
            type: this.type,
            county: this.county,
          }).then((res: any) => this.fetchListData(res));
        }, 150);
      }
    }
  }
  fetchListData(res: any) {
    this.showLoading = false;
    if (res.code === 100) {
      this.finished = true;
    } else {
      this.page = this.page + 1;
      this.getListData = [...this.getListData, ...res.data];
      // this.getListData = Array.from(new Set(this.getListData));
      console.log('this.getListData', this.getListData, this.page);
    }
    this.loading = false;
    this.loadingStatus = false;
  }
  // 进入详情页
  enterDetailPage(item: any) {
    // this.$router.push({ path: './DetailPage', query: { id: item.id } });
    this.$emit('enterDetailPage', item.id);
  }
  // 多选
  chooseOpus() {
    // bus.$emit('testF', this.result);
  }
  fetchSearch(e: any) {
    this.SearchData = e;
  }
  // 开始搜索
  startSearch(e: any) {
    console.log('进入搜索', e);
    this.loadingStatus = true;
    if (e === 1) {
      this.page = 1;
      this.getListData = [];
      this.loading = false;
      this.finished = false;
    }
    getVoteList({
      page: this.page,
      workType: this.workType,
      type: this.type,
      county: this.county,
      search: this.SearchData,
    }).then((res: any) => this.fetchListData(res));
  }
  searchNewsData(res: any) {
    this.getListData = [...res.data];
    this.finished = true;
  }
  enterDetail(i: any) {
    this.$router.push({
      path: './Detail',
      query: { id: i, source: this.$route.query.source },
    });
  }
}
